import { Component } from "react";
import { connect } from "react-redux";
import { skipFormFailSafe } from "../../../redux/actions/skipFormFailSafe";
import { FormErr } from "../formErr/FormErr";
import "./styles.css";

class FormErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    this.props.handleFailSafe({ err: error, errInfo: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="formErrorBoundary">
          <FormErr />
        </div>
      );
    }

    return this.props.children;
  }
}

const mapDispatchToProps = (dispatch) => ({
  handleFailSafe: (logs) => dispatch(skipFormFailSafe(logs)),
});

export default connect(null, mapDispatchToProps)(FormErrorBoundary);
